<template>
  <div class="z-card border-0">
    <h4 class="z-card__title">
      {{ $t('pbx.stat.common.block.acd') }}
    </h4>
    <div class="z-card__body">
      <column-chart :data="chart_data" :options="chart_options" />
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { DATA } from '@/plugins/vuex-async-pagginate';
  import { blue } from '@shared/helpers/css';
  import ColumnChart from '@shared/components/stats-chart-column';

  export default {
    components: {
      ColumnChart
    },
    computed: {
      ...mapGetters('pbx/stats/general/table', { items: DATA }),
      chart_options() {
        return {
          legend: { position: 'none' },
          vAxis: {
            format: `# '${this.$t('shared.unit.time.second.middle')}'`,
            viewWindow: {
              min: 0.1
            }
          },
          series: {
            0: { color: blue }
          }
        };
      },
      chart_data() {
        const columns = ['day', { type: 'number', label: this.$t('pbx.stat.common.block.acd') }];
        const values = this.items.map(i => [i['group'], i['acd']]);
        return [columns, ...values];
      }
    }
  };
</script>
